export const MobileSplitsColumns = (summaryUnitLabels) => {
    return [
      {
        title: "waypoint",
        dataKey: "title",
      },
      {
        title: "time",
        dataKey: "elapsedTime",
      },
      {
        title: summaryUnitLabels[1],
        dataKey: "distance",
      },
      {
        title: "pace",
        dataKey: "pace",
      },
    ];
  };